import { render, staticRenderFns } from "./HowToUseAMoxaStick.vue?vue&type=template&id=2513cfc0&"
import script from "./HowToUseAMoxaStick.vue?vue&type=script&lang=js&"
export * from "./HowToUseAMoxaStick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports